import { formatDateTime } from "Common/dateTimeUtils/format";
import { OPTION_TYPE } from "Common/dictionaries/optionType";
import find from "lodash/find";
import forEach from "lodash/forEach";
import isNumber from "lodash/isNumber";
import isString from "lodash/isString";
import join from "lodash/join";
export default (attributeValues, documentObject) => {
    var _a;
    if (!attributeValues || !documentObject || !((_a = documentObject.LabelAttributes) === null || _a === void 0 ? void 0 : _a.length))
        return "";
    const resultParts = [];
    forEach(documentObject.LabelAttributes, la => {
        const attrScheme = find(documentObject.Attributes, ["Key", la]);
        const attrVal = find(attributeValues, ["Key", la]);
        if (attrScheme && attrVal) {
            switch (attrScheme.Type) {
                case OPTION_TYPE.STRING:
                    if (isString(attrVal.Value))
                        resultParts.push(attrVal.Value);
                    break;
                case OPTION_TYPE.DATETIME:
                    if (isNumber(attrVal.Value))
                        resultParts.push(formatDateTime(attrVal.Value));
                    break;
                case OPTION_TYPE.INT:
                    if (isNumber(attrVal.Value))
                        resultParts.push(attrVal.Value.toString());
                    break;
                default:
                    break;
            }
        }
    });
    return join(resultParts, " ");
};
